import { GoOrganization } from "react-icons/go";
import { LuUser } from "react-icons/lu";
import { VscTypeHierarchySub } from "react-icons/vsc";

export const TagTypeIcons = {
	UNIT: VscTypeHierarchySub,
	ORGANIZATION: GoOrganization,
	PERSON: LuUser,
}